import {
  IonBackButton,
  IonButton, IonButtons,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonLoading,
  IonModal,
  IonNote,
  IonPage,
  IonRow,
  IonText,
  IonTitle,
  IonToolbar, useIonRouter,
} from "@ionic/react";
import React, {useRef, useState} from "react";
import Header from "../../components/Header";
import {AuthContext} from "../../providers/authContext";
import "./Page.css";
import {NfcCardInfo} from "../entities/NfcCardInfo";
import {useLocation} from "react-router-dom";
import {card, closeCircle, pin} from "ionicons/icons";
import Cards, {Focused} from "react-credit-cards";
import {InputMask} from "primereact/inputmask";
import {InputText} from "primereact/inputtext";
import Card from "../entities/CardInfo";
import 'react-credit-cards/es/styles-compiled.css';
import nfcService from "../../services/NfcService";
import TahsilatHazirla from "../entities/TahsilatHazirla";
import {CARD_ENROLLMENT_URL, HASH_URL, NFC_TAHSILAT_BASARILI, NFC_TAHSILAT_BASARISIZ} from "../../services/constants";
import {useBaylanCard} from "../../hooks/useBaylanCard";

type LocationState = {
  nfcCardInfo?: NfcCardInfo;
};

const NfcCardOperations: React.FC = () => {
  const { setTitle, kurumBilgileri } = React.useContext(AuthContext);
  const navigation = useIonRouter();
  const { readCard, loadCredit, startThreeDS } = useBaylanCard();
  const location = useLocation<LocationState>();
  const nfcCardInfo = location.state?.nfcCardInfo;
  const paymentFormRef = useRef<HTMLFormElement>(null);
  const [creditCard, setCreditCard] = useState<Card>(new Card());

  const [adiSoyadiUnvan, setAdiSoyadiUnvan] = useState("");
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalStep2, setShowModalStep2] = useState(false);
  const [showNfcReadModal, setShowNfcReadModal] = useState(false);
  const [showPaymentSuccess, setShowPaymentSuccess] = useState(false);
  const [referansNo, setReferansNo] = useState<string | undefined>("");
  const [tonAmount, setTonAmount] = useState<string>("");
  const [tutar, setTutar] = useState<number>(0.0);
  const [tutar5, setTutar5] = useState<number>(0.0);
  const [tutar10, setTutar10] = useState<number>(0.0);
  const [tutar15, setTutar15] = useState<number>(0.0);
  const [tutar20, setTutar20] = useState<number>(0.0);

  const modalRef = useRef<HTMLIonModalElement>(null);

  React.useEffect(() => {
    setTitle("NFC Kart İşlemleri");
  }, [setTitle]);

  React.useEffect(() => {
    if (!nfcCardInfo?.aboneNo || !nfcCardInfo?.sayacNo || !nfcCardInfo?.cardSeriNo) {
      return;
    }
    console.log("getNfcInfo metodu çağrılıyor:", JSON.stringify(nfcCardInfo));
    setShowLoading(true);
    nfcService.getNfcInfo(nfcCardInfo?.aboneNo!, nfcCardInfo?.sayacNo!, nfcCardInfo?.cardSeriNo!)
      .then(data => {
        console.log("Abone bilgileri alındı:", data);
        setAdiSoyadiUnvan(data.adiSoyadiUnvan);
        setTutar5(data.tutar5);
        setTutar10(data.tutar10);
        setTutar15(data.tutar15);
        setTutar20(data.tutar20);
      })
      .catch(err => {
        console.error("Abone bilgileri alınamadı:", err);
        alert("Abone bilgileri alınamadı. Lütfen tekrar deneyin.");
      })
      .finally(() => {
        setShowLoading(false);
      });
  }, [nfcCardInfo]);

  const handleTonButtonClick = (amount: string) => {
    setTonAmount(amount);
  };

  const handleContinue = () => {
    if (!tonAmount || isNaN(Number(tonAmount)) || Number(tonAmount) <= 0) {
      alert("Lütfen geçerli bir m³ miktarı giriniz.");
      return;
    }
    nfcService.getAmountInfo(nfcCardInfo?.aboneNo!, Number(tonAmount))
      .then(data => {
        setTutar(data);
        setShowModal(false);
        setShowModalStep2(true);
      })
      .catch(err => {
        console.error("Tutar bilgisi alınamadı:", err);
        alert("Tutar bilgisi alınamadı. Lütfen tekrar deneyin.");
      });
  };

  const postPaymentInfo = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!creditCard.cardNo || !creditCard.expiry || !creditCard.cvc) {
      alert("Lütfen tüm kredi kartı bilgilerini doldurunuz.");
      return;
    }
    setShowLoading(true);
    nfcService.tahsilatHazirla(nfcCardInfo?.aboneNo!, tutar)
      .then(async (data: TahsilatHazirla) => {
        const year = creditCard.expiry.slice(2);
        const month = creditCard.expiry.slice(0, 2);
        if (kurumBilgileri?.banka === "payflex") {
          let $xml = '';
          $xml += '<VposRequest>';
          $xml += '<MerchantId>' + kurumBilgileri?.eBelediyeClientId + '</MerchantId>';
          $xml += '<HashData>' + data.hash + '</HashData>';
          $xml += '<OrderId>' + data.oid + '</OrderId>';
          $xml += '<TransactionType>Sale</TransactionType>';
          $xml += '<Pan>' + creditCard.cardNo + '</Pan>';
          $xml += '<Expiry>20' + year + month + '</Expiry>';
          $xml += '<Cvv>' + creditCard.cvc + '</Cvv>';
          $xml += '<CurrencyAmount>' + tutar.toFixed(2) + '</CurrencyAmount>';
          $xml += '<CurrencyCode>949</CurrencyCode>';

          const ipResponse = await fetch('https://api.ipify.org?format=json');

          // Check if the response is successful
          if (!ipResponse.ok) {
            throw new Error('Failed to fetch IP');
          }
          const ipData = await ipResponse.json();

          $xml += '<ClientIp>' + ipData.ip + '</ClientIp>';
          $xml += '<SuccessUrl>' + NFC_TAHSILAT_BASARILI + '/' + nfcCardInfo?.aboneNo + '</SuccessUrl>';
          $xml += '<FailUrl>' + NFC_TAHSILAT_BASARISIZ + '</FailUrl>';
          $xml += '<StoreType>' + kurumBilgileri?.sanalPosTip + '</StoreType>';
          $xml += '<TransactionDeviceSource>0</TransactionDeviceSource>';
          $xml += '<NumberOfInstallments>1</NumberOfInstallments>';
          $xml += '<Location>1</Location>';
          $xml += '<MerchantType>1</MerchantType>';
          $xml += '<CardHoldersName>' + creditCard.name + '</CardHoldersName>';
          $xml += '<BrandName>' + (creditCard.cardNo.startsWith("4") ? 100 : creditCard.cardNo.startsWith("5") ? 200 : 300) + '</BrandName>';
          $xml += '<OrderDescription>E-Belediye Borç Ödeme</OrderDescription>';
          $xml += '<Extract>Sicil/Abone/TcNo ' + nfcCardInfo?.aboneNo + '</Extract>';
          $xml += '</VposRequest>';

          // Hidden input'un value'sunu güncelle (React state ile yönetebilirsin ama ref ile doğrudan da olur)
          if (paymentFormRef.current) {
            const prmstrInput = paymentFormRef.current.querySelector('input[name="prmstr"]') as HTMLInputElement;
            if (prmstrInput) {
              prmstrInput.value = $xml;
            }
            paymentFormRef.current.submit();
          }
        } else if (kurumBilgileri?.banka === "ipay3d") {
          const params = new URLSearchParams();
          params.append('Ecom_Payment_Card_ExpDate_Month', month);
          params.append('Ecom_Payment_Card_ExpDate_Year', year);
          params.append('pan', creditCard.cardNo);
          params.append('PurchaseAmount', tutar.toFixed(2));
          params.append('oid', data.oid);
          params.append('SessionInfo', nfcCardInfo?.aboneNo + " " + nfcCardInfo?.sayacNo + " " + nfcCardInfo?.cardSeriNo);

          const response = await fetch(CARD_ENROLLMENT_URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: params.toString()
          });
          // Check if the response is successful
          if (!response.ok) {
            throw new Error('Failed to fetch Acs data');
          }
          const acsData = await response.json();
          if (paymentFormRef.current) {
            const acsUrlInput = paymentFormRef.current.querySelector('input[name="AcsUrl"]') as HTMLInputElement;
            if (acsUrlInput) {
              acsUrlInput.value = acsData.acsUrl;
            }
            const paReqInput = paymentFormRef.current.querySelector('input[name="PaReq"]') as HTMLInputElement;
            if (paReqInput) {
              paReqInput.value = acsData.paReq;
            }
            const termUrlInput = paymentFormRef.current.querySelector('input[name="TermUrl"]') as HTMLInputElement;
            if (termUrlInput) {
              termUrlInput.value = acsData.termUrl;
            }
            const mdInput = paymentFormRef.current.querySelector('input[name="MD"]') as HTMLInputElement;
            if (mdInput) {
              mdInput.value = acsData.md;
            }
            paymentFormRef.current.action = acsData.acsUrl;
            paymentFormRef.current.submit();
          }
        } else {
          if (paymentFormRef.current) {
            const Ecom_Payment_Card_ExpDate_Month = paymentFormRef.current.querySelector('input[name="Ecom_Payment_Card_ExpDate_Month"]') as HTMLInputElement;
            Ecom_Payment_Card_ExpDate_Month.value = month;
            const Ecom_Payment_Card_ExpDate_Year = paymentFormRef.current.querySelector('input[name="Ecom_Payment_Card_ExpDate_Year"]') as HTMLInputElement;
            Ecom_Payment_Card_ExpDate_Year.value = year;
            const pan = paymentFormRef.current.querySelector('input[name="pan"]') as HTMLInputElement;
            pan.value = creditCard.cardNo;
            const rnd = paymentFormRef.current.querySelector('input[name="rnd"]') as HTMLInputElement;
            rnd.value = data.rnd;
            const oid = paymentFormRef.current.querySelector('input[name="oid"]') as HTMLInputElement;
            oid.value = data.oid;
            const amount = paymentFormRef.current.querySelector('input[name="amount"]') as HTMLInputElement;
            amount.value = tutar.toFixed(2);

            let formData = new FormData(paymentFormRef.current);
            const response = await fetch(HASH_URL, {
              method: 'POST',
              body: formData
            });

            // Check if the response is successful
            if (!response.ok) {
              throw new Error('Failed to fetch hash data');
            }

            // Parse the response JSON
            const hashdata = await response.text();
            const hash = paymentFormRef.current.querySelector('input[name="hash"]') as HTMLInputElement;
            hash.value = hashdata;

            // paymentFormRef.current.submit();
            formData = new FormData(paymentFormRef.current!);
            const result = await startThreeDS({
              postUrl: paymentFormRef.current.action,
              postData: Object.fromEntries(formData.entries()) as Record<string, string>
            });

            if (result.status === 'success') {
              // NFC kredi yükleme akışına geç
              setReferansNo(result.referansNo);
              setShowModalStep2(false);
              setShowPaymentSuccess(true);
            } else {
              alert(result.message ?? result.status);
            }
          }
        }
      })
      .catch((err) => {
        console.error(err);
        alert(err.response ? err.response.data.message : err);
      })
      .finally(() => setShowLoading(false));
  }

  const handleTransferToCard = () => {
    setShowNfcReadModal(true);
    const amountNumber = Number(tonAmount);

    loadCredit(amountNumber)
      .then(result => {
        if (result.kod === '00') {
          if (nfcCardInfo) {
            nfcCardInfo.mainCredit = (Number(nfcCardInfo.mainCredit) + amountNumber).toFixed(2);
          }
          nfcService.yuklemeKaydet(nfcCardInfo, referansNo!).catch(err => {
            console.error("NFC Yukleme Kaydet Error: ", err);
            alert("NFC Yukleme Kaydet Error: " + err.message);
          });
          setShowPaymentSuccess(false);
          setShowNfcReadModal(false);
          alert("Yükleme işlemi başarıyla tamamlandı.");
          navigation.push("/", "root", "replace");
        } else {
          // alert(`Karta Yazma Başarısız: ${result.aciklama}`);
          setShowNfcReadModal(false);
          alert(`Karta Yazma Başarısız. Lütfen Tekrar Deneyiniz`);
        }
      })
      .catch(err => {
        console.error("NFC Load Credit Error: ", err);
        alert(err.message);
      });
  };

  const openModal = () => {
    setTonAmount("");
    setCreditCard(new Card());
    setShowModal(true);
    setShowModalStep2(false);
  };

  const handleGoBack = () => {
    setShowModalStep2(false);
    setShowModal(true);
  };

  return (
    <IonPage>
      <IonHeader translucent>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/" />
          </IonButtons>
          <IonTitle size="large">NFC Kart İşlemleri</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonLoading
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={"Lütfen Bekleyin..."}
        />

        <div className="ion-padding content">
          {!nfcCardInfo ? (
            <IonText>
              <p>Bu sayfaya kart bilgisi gelmedi. Lütfen Ana Sayfa’dan kartı tekrar okutun.</p>
            </IonText>
          ) : (
            <>
              <IonItem color="light">
                <IonIcon icon={pin} slot="start" />
                <IonLabel className="ion-text-wrap">
                  Sayın {adiSoyadiUnvan}, kart bilgileriniz aşağıdaki
                  gibidir.
                </IonLabel>
              </IonItem>
              <IonList inset={true}>
                <IonItem>
                  <IonLabel>Abone No</IonLabel>
                  <IonNote className="nfc-value" slot="end">{Number(nfcCardInfo?.aboneNo)}</IonNote>
                </IonItem>
                <IonItem>
                  <IonLabel>Sayaç No</IonLabel>
                  <IonNote className="nfc-value" slot="end">{nfcCardInfo?.sayacNo}</IonNote>
                </IonItem>
                <IonItem>
                  <IonLabel>Kart Seri No</IonLabel>
                  <IonNote className="nfc-value" slot="end">{nfcCardInfo?.cardSeriNo}</IonNote>
                </IonItem>
                <IonItem>
                  <IonLabel>Ana Kredi</IonLabel>
                  <IonNote className="nfc-value" slot="end">{nfcCardInfo?.mainCredit}</IonNote>
                </IonItem>
                <IonItem>
                  <IonLabel>Borç Kredisi</IonLabel>
                  <IonNote className="nfc-value" slot="end">{nfcCardInfo?.debtCredit}</IonNote>
                </IonItem>
                <IonItem>
                  <IonLabel>Yedek Kredi</IonLabel>
                  <IonNote className="nfc-value" slot="end">{nfcCardInfo?.reserveCredit}</IonNote>
                </IonItem>
                <IonItem>
                  <IonLabel>Toplam Tüketim</IonLabel>
                  <IonNote className="nfc-value" slot="end">{nfcCardInfo?.totalConsumption}</IonNote>
                </IonItem>
              </IonList>

              <div className="ion-padding">
                <IonButton expand="block" onClick={openModal}>
                  Bakiye Yükle
                </IonButton>
              </div>

              <IonModal
                ref={modalRef}
                isOpen={showModal}
                onDidDismiss={() => setShowModal(false)}
                initialBreakpoint={0.5}
                breakpoints={[0, 0.5]}
                handleBehavior="cycle"
                handle={true}
              >
                <IonHeader>
                  <IonToolbar>
                    <IonTitle>Bakiye Yükle</IonTitle>
                    <IonButton slot="end" fill="clear" onClick={() => setShowModal(false)}>
                      <IonIcon icon={closeCircle} />
                    </IonButton>
                  </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                  <div className="modal-step-1">
                    <IonGrid>
                      <IonRow>
                        <IonCol size="6">
                          <IonButton expand="block" fill="outline" className="unit-button" onClick={() => handleTonButtonClick("5")}>5 m<sup>3</sup> ({tutar5} ₺)</IonButton>
                        </IonCol>
                        <IonCol size="6">
                          <IonButton expand="block" fill="outline" className="unit-button" onClick={() => handleTonButtonClick("10")}>10 m<sup>3</sup> ({tutar10} ₺)</IonButton>
                        </IonCol>
                      </IonRow>
                      <IonRow>
                        <IonCol size="6">
                          <IonButton expand="block" fill="outline" className="unit-button" onClick={() => handleTonButtonClick("15")}>15 m<sup>3</sup> ({tutar15} ₺)</IonButton>
                        </IonCol>
                        <IonCol size="6">
                          <IonButton expand="block" fill="outline" className="unit-button" onClick={() => handleTonButtonClick("20")}>20 m<sup>3</sup> ({tutar20} ₺)</IonButton>
                        </IonCol>
                      </IonRow>
                    </IonGrid>
                    <IonItem className="ion-margin-top">
                      <IonLabel position="stacked">m<sup>3</sup> Miktarı</IonLabel>
                      <IonInput
                        type="number"
                        placeholder="Diğer m³ Miktarını Giriniz"
                        value={tonAmount}
                        onIonChange={e => setTonAmount(e.detail.value!)}
                        required
                      />
                    </IonItem>
                    <div className="ion-padding-top">
                      <IonButton expand="block" onClick={handleContinue}>Devam Et</IonButton>
                    </div>
                  </div>
                </IonContent>
              </IonModal>

              <IonModal
                isOpen={showModalStep2}
                onDidDismiss={() => setShowModalStep2(false)}
              >
                <IonHeader>
                  <IonToolbar>
                    <IonTitle>Ödeme Bilgileri</IonTitle>
                    <IonButton slot="end" fill="clear" onClick={() => setShowModalStep2(false)}>
                      <IonIcon icon={closeCircle} />
                    </IonButton>
                  </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                  <div className="modal-step-2">
                    <IonList>
                      <IonItem lines="none">
                        <IonLabel>
                          <h2>Yüklenecek Su Miktarı: <strong>{tonAmount} m³</strong></h2>
                          <p>Tutar: <strong>{tutar} ₺</strong></p>
                        </IonLabel>
                      </IonItem>
                      <IonRow>
                        <IonCol size="12" className="ion-text-center">
                          <Cards
                            cvc={creditCard.cvc}
                            expiry={creditCard.expiry}
                            focused={creditCard.focus}
                            name={creditCard.name}
                            number={creditCard.cardNo}
                            placeholders={{name: 'ADI SOYADI'}}
                          />
                        </IonCol>
                      </IonRow>
                      <IonRow>
                        <IonCol size="12">
                          <form id="paymentInfoForm" name="paymentInfoForm" method="post"
                                action={kurumBilgileri?.sanalPosUrl} onSubmit={(e) => postPaymentInfo(e)}>
                            <IonRow className="ion-align-items-center">
                              <IonCol size="4">
                                <IonLabel>Kart No</IonLabel>
                              </IonCol>
                              <IonCol size="8">
                                <InputMask
                                  id="number" slotChar="-" unmask
                                  style={{width: '100%', padding: '8px'}}
                                  name="number" value={creditCard.cardNo}
                                  onFocus={(e) => setCreditCard({...creditCard, focus: e.target.name as Focused})}
                                  onChange={(e) => setCreditCard({...creditCard, cardNo: e.value})}
                                  mask="9999 9999 9999 9999"/>
                              </IonCol>
                            </IonRow>
                            <IonRow className="ion-margin-top ion-align-items-center">
                              <IonCol size="4">
                                <IonLabel>Ad Soyad</IonLabel>
                              </IonCol>
                              <IonCol size="8">
                                <InputText
                                  id="name"
                                  style={{width: '100%', padding: '8px'}}
                                  name="name" value={creditCard.name}
                                  onFocus={(e) => setCreditCard({...creditCard, focus: e.target.name as Focused})}
                                  onChange={(e) => setCreditCard({...creditCard, name: e.target.value})}/>
                              </IonCol>
                            </IonRow>
                            <IonRow className="ion-margin-top ion-align-items-center">
                              <IonCol size="4">
                                <IonLabel>Son Kul.</IonLabel>
                              </IonCol>
                              <IonCol size="3">
                                <InputMask
                                  id="expiry" slotChar="-" unmask
                                  style={{width: '100%', padding: '8px'}}
                                  name="expiry" value={creditCard.expiry}
                                  onFocus={(e) => setCreditCard({...creditCard, focus: e.target.name as Focused})}
                                  onChange={(e) => setCreditCard({...creditCard, expiry: e.value})}
                                  mask="99/99"/>
                              </IonCol>
                              <IonCol size="2" className="ion-text-end">
                                <IonLabel>CVC</IonLabel>
                              </IonCol>
                              <IonCol size="3">
                                <InputMask
                                  id="cvc" slotChar="-" unmask
                                  style={{width: '100%', padding: '8px'}}
                                  name="cvc" value={creditCard.cvc}
                                  onFocus={(e) => setCreditCard({...creditCard, focus: e.target.name as Focused})}
                                  onChange={(e) => setCreditCard({...creditCard, cvc: e.value})}
                                  mask="999"/>
                              </IonCol>
                            </IonRow>
                          </form>

                          <form id="payflexForm" ref={paymentFormRef} method="POST" action={kurumBilgileri?.sanalPosUrl}>
                            {kurumBilgileri?.banka === "payflex" ?
                              <input type="hidden" name="prmstr" value=""/>
                              : kurumBilgileri?.banka === "ipay3d" ?
                                <>
                                  <input type="hidden" id="AcsUrl" name="AcsUrl"/>
                                  <input type="hidden" id="PaReq" name="PaReq"/>
                                  <input type="hidden" id="TermUrl" name="TermUrl"/>
                                  <input type="hidden" id="MD" name="MD"/>
                                </>
                                :
                                <>
                                  <input type="hidden" id="encoding" name="encoding" value="UTF-8"/>
                                  <input type="hidden" id="clientid" name="clientid"
                                         value={kurumBilgileri?.eBelediyeClientId}/>
                                  <input type="hidden" id="fulkekod" name="fulkekod" value="tr"/>
                                  <input type="hidden" id="lang" name="lang" value="tr"/>
                                  <input type="hidden" id="currency" name="currency" value="949"/>
                                  <input type="hidden" id="hashAlgorithm" name="hashAlgorithm" value="ver3"/>
                                  <input type="hidden" id="refreshtime" name="refreshtime" value="5"/>
                                  <input type="hidden" id="taksit" name="taksit" value=""/>
                                  <input type="hidden" id="islemtipi" name="islemtipi" value="Auth"/>
                                  <input type="hidden" id="rnd" name="rnd"/>
                                  <input type="hidden" id="storetype" name="storetype"
                                         value={kurumBilgileri?.sanalPosTip}/>
                                  <input type="hidden" id="hash" name="hash"/>
                                  <input type="hidden" id="amount" name="amount"/>
                                  <input type="hidden" id="oid" name="oid"/>
                                  <input type="hidden" id="okUrl" name="okUrl" value={NFC_TAHSILAT_BASARILI + '/' + nfcCardInfo?.aboneNo}/>
                                  <input type="hidden" id="failUrl" name="failUrl" value={NFC_TAHSILAT_BASARISIZ} />
                                  <input type="hidden" id="name" name="name"/>
                                  <input type="hidden" id="pan" name="pan"/>
                                  <input type="hidden" id="Ecom_Payment_Card_ExpDate_Month"
                                         name="Ecom_Payment_Card_ExpDate_Month"/>
                                  <input type="hidden" id="Ecom_Payment_Card_ExpDate_Year"
                                         name="Ecom_Payment_Card_ExpDate_Year"/>
                                  <input type="hidden" id="askidaFatura" name="askidaFatura" value="false"/>
                                </>}
                          </form>
                        </IonCol>
                      </IonRow>
                    </IonList>
                    <div className="ion-padding-top">
                      <IonButton expand="block" type="submit" form="paymentInfoForm" color="success">
                        <IonIcon slot="start" icon={card}/>
                        <IonText>Ödeme Yap</IonText>
                      </IonButton>
                      <IonButton expand="block" fill="clear" onClick={handleGoBack} color="medium">Geri Dön</IonButton>
                    </div>
                  </div>
                </IonContent>
              </IonModal>

              <IonModal
                isOpen={showNfcReadModal}
                onDidDismiss={() => setShowNfcReadModal(false)}
                initialBreakpoint={0.5}
                breakpoints={[0, 0.5, 0.75]}
              >
                <IonContent className="ion-padding">
                  <IonText>
                    <h2>Kartı Tekrar Okutunuz</h2>
                    <p>Ödeme Başarılı. Bakiye yüklemek için lütfen kartı cihaza okutunuz</p>
                  </IonText>

                  <div style={{ display: "flex", justifyContent: "center", margin: "16px 0" }}>
                    <img
                      src="assets/NFC.gif"
                      alt="NFC"
                      style={{ width: 225, maxWidth: "80%", height: "auto" }}
                    />
                  </div>

                  <IonButton expand="block" onClick={() => setShowNfcReadModal(false)}>
                    Vazgeç
                  </IonButton>
                </IonContent>
              </IonModal>

              <IonModal isOpen={showPaymentSuccess} onDidDismiss={() => setShowPaymentSuccess(false)}>
                {/*<IonHeader>*/}
                {/*  <IonToolbar>*/}
                {/*    <IonTitle>Ödeme Başarılı</IonTitle>*/}
                {/*    <IonButton slot="end" fill="clear" onClick={() => setShowPaymentSuccess(false)}>*/}
                {/*      <IonIcon icon={closeCircle} />*/}
                {/*    </IonButton>*/}
                {/*  </IonToolbar>*/}
                {/*</IonHeader>*/}
                <IonContent color="light">
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    padding: '20px',
                    textAlign: 'center'
                  }}>
                    <IonText color="success">
                      <h1 style={{fontSize: '2rem', fontWeight: 'bold'}}>Ödeme Başarılı</h1>
                    </IonText>
                    <IonText color="dark">
                      <p style={{fontSize: '1.2rem'}}>Referans No: {referansNo}</p>
                    </IonText>
                    <IonText color="medium">
                      <p style={{marginTop: '20px', marginBottom: '30px'}}>
                        Yüklemeyi kartınıza aktarmak için aşağıdaki Karta Aktar butonuna tıklayınız.
                      </p>
                    </IonText>
                    <IonButton expand="block" size="large" onClick={handleTransferToCard} color="success" style={{width: '100%'}}>
                      Karta Aktar
                    </IonButton>
                  </div>
                </IonContent>
              </IonModal>
            </>
          )}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default NfcCardOperations;
